import React from 'react';
import { Anchor, Heading, Separator, THeadingLevel, Text } from 'telia-front-react';

interface Props {
  /**
   * Article date
   */
  date: string;
  /**
   * Article title
   */
  title: string;
  /**
   * Read more link
   */
  anchor?: {
    /**
     * Read more url
     */
    url: string;
    /**
     * Read more url text
     */
    text: string;
  };
  /**
   * Content
   */
  children?: React.ReactNode;
  /**
   * Additional custom class.
   */
  className?: string;
  /**
   * Level of title heading. For article default is 1, otherwise 3
   */
  headingLevel?: THeadingLevel;
}

export const NewsItem = ({ date, headingLevel, title, children, anchor }: Props) => {
  return (
    <Text>
      <div>
        <p className="text-tiny">{date}</p>
        <Heading level={headingLevel} className="h4 text-bold">
          {title}
        </Heading>
      </div>
      {children && <Text>{children}</Text>}
      <Separator spacing="small" color="invisible" />
      {anchor && <Anchor url={anchor.url}>{anchor.text}</Anchor>}
    </Text>
  );
};
